interface MentorCVProgressBarProps {
  percent?: number;
}

export default function MentorCVProgressBar({
  percent = 0,
}: MentorCVProgressBarProps) {
  const isLow = percent < 60;
  const fillColor = isLow ? '#FFB74D' : '#22C55E';

  return (
    <div className="flex flex-col gap-3">
      {percent < 100 && (
        <div className="text-xs text-gray-500">
          Та CV-гээ 100% хүртэл бүрэн бөглөж ажлын санал авах боломжоо ихэсгээрэй.
        </div>
      )}
      <div className="relative w-full h-6 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-300 flex items-center justify-center"
          style={{ width: `${percent}%`, backgroundColor: fillColor }}
        >
          {percent > 5 && (
            <span className="text-white text-xs font-medium">{percent}%</span>
          )}
        </div>
      </div>
    </div>
  );
}
